module.exports = __webpack_public_path__ + "media/img/uploads/event-featured-thumb-02-921f82c3cbfbfdc02673aac4fd4bfa7d.jpg";